import React, { Component } from "react"
import config from "react-global-configuration"
import TabPanes from "../../../styleguide/js/components/tab-panes.js"
import { Link } from "react-router-dom"
import * as path from "../../constants/Paths"
import * as tracking from "../../helpers/tracking"

class ParkingProductBrowser extends Component {
  constructor(props) {
    super(props)
    this.tabPanesContainerRef = React.createRef()
    // rest of your state initialization
  }

  static defaultProps = {
    parkingList: "",
    parkingMap: "",
  }

  componentDidMount() {
    new TabPanes({ el: this.tabPanesContainerRef.current })
  }

  handleTrackingClick = (eventLabel) => {
    tracking.trackParkingFlowClick("all parking options tab", eventLabel, this.props)
  }

  render() {
    const textKeys = config.get("textKeys.parkingList") || {}
    const textKeyTabs = config.get("textKeys.parkingList.tabs") || {}
    const textKeyBack = config.get("textKeys.amendment.manage") || {}

    const showMapInitially = this.props.changeFromBookingGuid ? false : this.props.showMapInitially

    return (
      <section className="deck deck--static deck--padding-bottom deck--white js--scroll-anchor" id="parkingProductBrowser">
        <div className="parking-product-browser">
          <div className="tab-panes tab-panes--two-tabs js--tab-panes" data-mobileactiveid={1} ref={this.tabPanesContainerRef}>
            <nav className="tab-panes__navigation">
              <div className="w--wider">
                <div className="tab-panes__navigation__primary">
                  <h3>{textKeys.title || "Alle parkeringsmuligheder"}</h3>
                  <div className="tab-panes__navigation__primary__inner">
                    <a
                      className={`button js--secondary-tab ${showMapInitially ? "is-active" : ""}`}
                      data-contentid={0}
                      onClick={() => this.handleTrackingClick("map")}
                    >
                      <span className="icon">
                        <svg className="svg-icon svg-icon--pin">
                          <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/dist/svg/symbols.svg#svg-pin">
                            &nbsp;
                          </use>
                        </svg>
                      </span>
                      <span className="text">{textKeyTabs.map || "Kort"}</span>
                    </a>
                    <a
                      className={`button js--secondary-tab ${!showMapInitially ? "is-active" : ""}`}
                      data-contentid={1}
                      onClick={() => this.handleTrackingClick("list")}
                    >
                      <span className="icon">
                        <svg className="svg-icon svg-icon--burgermenu">
                          <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/dist/svg/symbols.svg#svg-burgermenu">
                            &nbsp;
                          </use>
                        </svg>
                      </span>
                      <span className="text">{textKeyTabs.list || "Liste"}</span>
                    </a>
                  </div>
                </div>
              </div>
            </nav>
            <div className="tab-panes__content">
              <div
                className={`tab-panes__content__inner js--content ${showMapInitially ? "is-active" : ""}`}
                style={{ display: showMapInitially ? "block" : "none" }}
                data-contentid={0}
                data-eventname="map:activate"
              >
                <div className="w--wider">{this.props.parkingMap}</div>
              </div>
              <div
                className={`tab-panes__content__inner js--content ${!showMapInitially ? "is-active" : ""}`}
                style={{ display: !showMapInitially ? "block" : "none" }}
                data-contentid={1}
              >
                {this.props.parkingList}
              </div>
            </div>
          </div>
        </div>
        {this.props.isAmendment ? (
          <div className="backlink-center">
            <Link className="link" to={`${path.AMMEND_EDIT_TIME()}${this.props.location.search}`}>
              {textKeyBack.backText || "Tilbage"}
            </Link>
          </div>
        ) : null}
      </section>
    )
  }
}
export default ParkingProductBrowser
